import {
  type ParameterRecord,
  unpackParameterRecord,
} from '@robovision/data'
import type { HubResource } from '@robovision/hub'
import { defineStore } from 'pinia'
import {
  reactive,
  readonly,
  toRefs,
} from 'vue'
import { hubApi } from '~services/api'


interface ParametersState {
  parameters: Record<string, ParameterRecord>
}

export const useParametersStore = defineStore('parameters', () => {
  const state = reactive<ParametersState>({
    parameters: {},
  }) as ParametersState

  const getters = {
    getParameter (id: string): ParameterRecord | undefined {
      return state.parameters[id]
    },
  }

  const actions = {
    async loadParameter (resourceId: string): Promise<void> {
      try {
        const { data } = await hubApi.resources.getParametersResourceData(resourceId)
        const record = await unpackParameterRecord(data)
        state.parameters[resourceId] = record
      } catch (e) {
        console.log(e)
      }
    },

    async loadParameters (
      resources: HubResource[],
    ): Promise<void> {
      await Promise.all(
        resources
          .flatMap(r => Array.isArray(r) ? r : [r])
          .map(r => this.loadParameter(r.id)),
      )
    },

    setState (params: Partial<typeof state>): void {
      Object.assign(state, params)
    },
  }

  return {
    ...toRefs(readonly(state)),
    ...getters,
    ...actions,
  }
})
